var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatNow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 51,
    viewBox: "0 0 93 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.000110865,
    y: -1.27591,
    width: 92.3796,
    height: 51.6555
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.96px)",
      clipPath: "url(#bgblur_0_2037_1200_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2037_1200)",
    "data-figma-bg-blur-radius": 1.91388
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.1897,
    y: 0.63797,
    width: 86,
    height: 44,
    rx: 9.56942,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.1897,
    y: 0.63797,
    width: 86,
    height: 44,
    rx: 9.56942,
    fill: "url(#paint0_linear_2037_1200)",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.1897,
    y: 0.63797,
    width: 86,
    height: 44,
    rx: 9.56942,
    fill: "url(#paint1_linear_2037_1200)",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.50868,
    y: 0.956951,
    width: 85.362,
    height: 43.362,
    rx: 9.25044,
    stroke: "url(#paint2_radial_2037_1200)",
    strokeWidth: 0.637962,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1322 15.8191H57.804C57.7662 15.6013 57.6963 15.4083 57.5945 15.2402C57.4927 15.0698 57.3661 14.9254 57.2146 14.807C57.063 14.6886 56.8902 14.5999 56.6961 14.5407C56.5043 14.4791 56.2972 14.4483 56.0746 14.4483C55.6793 14.4483 55.3289 14.5478 55.0235 14.7466C54.7181 14.9431 54.479 15.232 54.3062 15.6131C54.1334 15.9919 54.0469 16.4547 54.0469 17.0016C54.0469 17.558 54.1334 18.0267 54.3062 18.4079C54.4814 18.7866 54.7205 19.0731 55.0235 19.2672C55.3289 19.459 55.6781 19.5549 56.0711 19.5549C56.2889 19.5549 56.4925 19.5265 56.6819 19.4696C56.8736 19.4105 57.0453 19.324 57.1968 19.2104C57.3507 19.0968 57.4797 18.9571 57.5839 18.7914C57.6904 18.6257 57.7638 18.4363 57.804 18.2232L59.1322 18.2303C59.0825 18.5759 58.9747 18.9003 58.809 19.2033C58.6457 19.5063 58.4314 19.7739 58.1663 20.0059C57.9011 20.2355 57.591 20.4154 57.2359 20.5456C56.8807 20.6735 56.4866 20.7374 56.0533 20.7374C55.4141 20.7374 54.8436 20.5894 54.3417 20.2935C53.8398 19.9976 53.4444 19.5703 53.1556 19.0115C52.8668 18.4528 52.7224 17.7829 52.7224 17.0016C52.7224 16.218 52.868 15.548 53.1592 14.9917C53.4504 14.433 53.8469 14.0056 54.3488 13.7097C54.8507 13.4138 55.4189 13.2658 56.0533 13.2658C56.4582 13.2658 56.8346 13.3226 57.1826 13.4363C57.5306 13.5499 57.8407 13.7168 58.113 13.937C58.3852 14.1548 58.609 14.4223 58.7842 14.7395C58.9617 15.0544 59.0777 15.4142 59.1322 15.8191ZM61.5674 17.4419V20.638H60.2818V13.3652H61.539V16.1103H61.6029C61.7307 15.8025 61.9284 15.5598 62.1959 15.3823C62.4658 15.2024 62.8091 15.1124 63.2257 15.1124C63.6045 15.1124 63.9348 15.1917 64.2165 15.3503C64.4982 15.5089 64.716 15.741 64.8699 16.0464C65.0262 16.3517 65.1043 16.7246 65.1043 17.165V20.638H63.8188V17.3638C63.8188 16.9969 63.7241 16.7116 63.5347 16.508C63.3477 16.302 63.0849 16.199 62.7463 16.199C62.5191 16.199 62.3155 16.2488 62.1355 16.3482C61.958 16.4453 61.8183 16.5861 61.7165 16.7708C61.6171 16.9554 61.5674 17.1792 61.5674 17.4419ZM67.9843 20.7481C67.6386 20.7481 67.3273 20.6865 67.0503 20.5634C66.7757 20.4379 66.5579 20.2533 66.3969 20.0094C66.2383 19.7656 66.159 19.4649 66.159 19.1074C66.159 18.7997 66.2158 18.5452 66.3294 18.3439C66.4431 18.1427 66.5981 17.9817 66.7946 17.861C66.9911 17.7402 67.2125 17.6491 67.4587 17.5875C67.7073 17.5236 67.9641 17.4775 68.2293 17.449C68.5489 17.4159 68.8081 17.3863 69.007 17.3603C69.2059 17.3319 69.3503 17.2892 69.4402 17.2324C69.5326 17.1732 69.5787 17.0821 69.5787 16.959V16.9377C69.5787 16.6702 69.4994 16.463 69.3408 16.3162C69.1822 16.1695 68.9537 16.0961 68.6554 16.0961C68.3406 16.0961 68.0908 16.1647 67.9061 16.302C67.7238 16.4393 67.6007 16.6015 67.5368 16.7885L66.3365 16.6181C66.4312 16.2866 66.5875 16.0097 66.8053 15.7871C67.0231 15.5622 67.2894 15.3941 67.6043 15.2829C67.9192 15.1692 68.2672 15.1124 68.6483 15.1124C68.9111 15.1124 69.1727 15.1432 69.4331 15.2047C69.6935 15.2663 69.9315 15.3681 70.1469 15.5101C70.3623 15.6498 70.5352 15.8404 70.6654 16.0819C70.7979 16.3233 70.8642 16.6252 70.8642 16.9874V20.638H69.6284V19.8887H69.5858C69.5077 20.0402 69.3976 20.1822 69.2556 20.3148C69.1159 20.445 68.9395 20.5504 68.7265 20.6309C68.5158 20.709 68.2684 20.7481 67.9843 20.7481ZM68.3181 19.8035C68.5761 19.8035 68.7998 19.7526 68.9892 19.6508C69.1786 19.5466 69.3242 19.4093 69.426 19.2388C69.5302 19.0684 69.5823 18.8825 69.5823 18.6813V18.0385C69.542 18.0717 69.4734 18.1025 69.3763 18.1309C69.2816 18.1593 69.1751 18.1841 69.0567 18.2054C68.9383 18.2267 68.8211 18.2457 68.7051 18.2623C68.5891 18.2788 68.4885 18.293 68.4033 18.3049C68.2115 18.3309 68.0399 18.3735 67.8884 18.4327C67.7369 18.4919 67.6173 18.5748 67.5297 18.6813C67.4421 18.7855 67.3983 18.9204 67.3983 19.0861C67.3983 19.3229 67.4847 19.5016 67.6576 19.6223C67.8304 19.7431 68.0506 19.8035 68.3181 19.8035ZM74.8806 15.1834V16.1777H71.7449V15.1834H74.8806ZM72.5191 13.8766H73.8046V18.9973C73.8046 19.1702 73.8306 19.3027 73.8827 19.3951C73.9372 19.485 74.0082 19.5466 74.0958 19.5797C74.1834 19.6129 74.2804 19.6294 74.387 19.6294C74.4675 19.6294 74.5408 19.6235 74.6071 19.6117C74.6758 19.5999 74.7279 19.5892 74.7634 19.5797L74.98 20.5847C74.9113 20.6084 74.8131 20.6344 74.6853 20.6628C74.5598 20.6912 74.4059 20.7078 74.2236 20.7125C73.9016 20.722 73.6116 20.6735 73.3536 20.5669C73.0955 20.458 72.8908 20.29 72.7392 20.0627C72.5901 19.8354 72.5167 19.5513 72.5191 19.2104V13.8766ZM58.8836 25.3652V32.638H57.7117L54.2849 27.6841H54.2245V32.638H52.907V25.3652H54.086L57.5093 30.3226H57.5732V25.3652H58.8836ZM62.6416 32.7445C62.1089 32.7445 61.6473 32.6273 61.2566 32.3929C60.866 32.1586 60.563 31.8307 60.3475 31.4093C60.1345 30.9879 60.0279 30.4955 60.0279 29.932C60.0279 29.3686 60.1345 28.8749 60.3475 28.4512C60.563 28.0274 60.866 27.6983 61.2566 27.464C61.6473 27.2296 62.1089 27.1124 62.6416 27.1124C63.1742 27.1124 63.6359 27.2296 64.0265 27.464C64.4171 27.6983 64.719 28.0274 64.9321 28.4512C65.1475 28.8749 65.2552 29.3686 65.2552 29.932C65.2552 30.4955 65.1475 30.9879 64.9321 31.4093C64.719 31.8307 64.4171 32.1586 64.0265 32.3929C63.6359 32.6273 63.1742 32.7445 62.6416 32.7445ZM62.6487 31.7147C62.9375 31.7147 63.179 31.6354 63.3731 31.4767C63.5672 31.3158 63.7117 31.1003 63.8064 30.8304C63.9034 30.5606 63.9519 30.2599 63.9519 29.9285C63.9519 29.5946 63.9034 29.2928 63.8064 29.0229C63.7117 28.7507 63.5672 28.534 63.3731 28.3731C63.179 28.2121 62.9375 28.1316 62.6487 28.1316C62.3528 28.1316 62.1065 28.2121 61.91 28.3731C61.7159 28.534 61.5703 28.7507 61.4733 29.0229C61.3786 29.2928 61.3312 29.5946 61.3312 29.9285C61.3312 30.2599 61.3786 30.5606 61.4733 30.8304C61.5703 31.1003 61.7159 31.3158 61.91 31.4767C62.1065 31.6354 62.3528 31.7147 62.6487 31.7147ZM67.3158 32.638L65.7746 27.1834H67.0849L68.0437 31.0187H68.0935L69.0736 27.1834H70.3697L71.3499 30.9973H71.4031L72.3477 27.1834H73.6616L72.1169 32.638H70.7781L69.7554 28.9519H69.6808L68.6581 32.638H67.3158Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2037_1200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.1897,
    y: 5.63797,
    width: 34,
    height: 33,
    rx: 8,
    fill: "#21A7DF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6897,
    y: 6.13797,
    width: 33,
    height: 32,
    rx: 7.5,
    stroke: "url(#paint3_linear_2037_1200)",
    strokeOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.113 23.1442C29.858 23.6474 28.5032 23.9578 27.0862 24.0382C26.8419 24.0521 26.5956 24.0591 26.3478 24.0591C26.0999 24.0591 25.8537 24.0521 25.6093 24.0382C24.192 23.9577 22.837 23.6472 21.5816 23.1438C18.9473 22.0873 16.7521 20.1812 15.3428 17.7685C17.5395 14.008 21.6453 11.478 26.3478 11.478C31.0503 11.478 35.1561 14.008 37.3528 17.7685C35.9433 20.1814 33.7478 22.0877 31.113 23.1442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5814 24.1231C21.278 24.0014 20.9803 23.8684 20.689 23.7247C19.7423 24.3851 18.942 25.2076 18.3394 26.146C19.3637 27.7411 20.9591 29.0013 22.8738 29.6998C23.7861 30.0326 24.771 30.2379 25.8011 30.2911H26.8745C27.9044 30.2379 29.7145 31.2483 27.086 33.7979C29.001 33.0995 33.3118 27.7413 34.3362 26.146C33.7353 25.2103 32.9379 24.3898 31.9947 23.7303C31.7068 23.872 31.4126 24.0033 31.1128 24.1235C29.8578 24.6267 28.503 24.9371 27.086 25.0175C26.8417 25.0314 26.5955 25.0384 26.3476 25.0384C26.0997 25.0384 25.8535 25.0314 25.6091 25.0175C24.1918 24.937 22.8368 24.6265 21.5814 24.1231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.041,
    y: 16.1593,
    width: 10.6365,
    height: 3.7618,
    rx: 1.8809,
    fill: "#162550"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2924,
    cy: 18.0194,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#04FED1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.3378,
    cy: 27.2984,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#162550"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5524,
    cy: 18.0194,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#04FED1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5524,
    cy: 27.2984,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#162550"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1239,
    cy: 27.2984,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#162550"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2037_1200",
    x: -0.000110865,
    y: -1.27591,
    width: 92.3796,
    height: 51.6555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.55185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5949
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2037_1200"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.27592
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.637962
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2037_1200",
    result: "effect2_dropShadow_2037_1200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2037_1200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2037_1200_clip_path",
    transform: "translate(0.000110865 1.27591)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.1897,
    y: 0.63797,
    width: 86,
    height: 44,
    rx: 9.56942
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2037_1200",
    x: 7.1897,
    y: 5.63797,
    width: 42,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.654902 0 0 0 0 0.87451 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2037_1200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2037_1200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2037_1200",
    x1: 71.6457,
    y1: 42.504,
    x2: 81.4775,
    y2: 2.42081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C44FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21A7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2037_1200",
    x1: 16.6917,
    y1: 44.506,
    x2: 40.5562,
    y2: 17.5298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21A7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C44FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2037_1200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(71.5248 57.5 -130.763 57.0186 30.863 8.13797)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21A7DF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2037_1200",
    x1: 9.1897,
    y1: 22.138,
    x2: 43.1897,
    y2: 22.1568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C94AB",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115531,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878072,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C94AB",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNow);
export default __webpack_public_path__ + "static/media/chat-now.9366bd5c1bbd21ffcf243ecdd0be2ca1.svg";
export { ForwardRef as ReactComponent };